import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

export type AddonRevenueSource = 'ncmic' | 'practisync';

export type AddonRevenueMonthlyRow = {
  id: number;
  source: AddonRevenueSource;
  period: string; // YYYY-MM-01
  amount: number;
  notes: string | null;
  enabled: boolean | number;
  created_at?: string;
  updated_at?: string;
  updated_by_email?: string | null;
};

type AddonRevenueMonthlyListResponse = {
  data: AddonRevenueMonthlyRow[];
  skip?: number;
};

type AddonRevenueMonthlyUpsert = {
  source: AddonRevenueSource;
  period: string; // YYYY-MM or YYYY-MM-DD
  amount: number;
  notes?: string;
  enabled?: boolean;
};

type AddonRevenueMonthlySeriesPoint = { date: string; value: number };
type AddonRevenueMonthlySeriesResponse = {
  source: AddonRevenueSource;
  series: AddonRevenueMonthlySeriesPoint[];
};

const addonRevenueMonthlyService = () => {
  const list = async (params?: {
    source?: AddonRevenueSource;
    enabled?: boolean;
    skip?: number;
    limit?: number;
  }): Promise<AddonRevenueMonthlyListResponse> => {
    return ChiroUpAPI.get('api', '/analytics/addon-revenue-monthly', {
      queryParams: params,
    });
  };

  const create = async (body: AddonRevenueMonthlyUpsert) => {
    return ChiroUpAPI.post('api', '/analytics/addon-revenue-monthly', { body });
  };

  const update = async (id: number, body: AddonRevenueMonthlyUpsert) => {
    return ChiroUpAPI.put('api', `/analytics/addon-revenue-monthly/${id}`, { body });
  };

  const del = async (id: number) => {
    return ChiroUpAPI.del('api', `/analytics/addon-revenue-monthly/${id}`, {});
  };

  const series = async (source: AddonRevenueSource): Promise<AddonRevenueMonthlySeriesResponse> => {
    return ChiroUpAPI.get('api', `/analytics/addon-revenue-monthly/series/${source}`, {});
  };

  return { list, create, update, del, series };
};

export default addonRevenueMonthlyService();
